// Push notification constants
export const APPLICATION_KEYS = {
  // VAPID public key for push notifications
  // This will be dynamically loaded from the backend config endpoint
  publicKey: process.env.REACT_APP_VAPID_PUBLIC_KEY
};


// Backend endpoint for sending push messages
export const BACKEND_ORIGIN = window.location.origin;

// Default notification options
export const DEFAULT_NOTIFICATION_OPTIONS = {
  icon: '/sloot_logo.png',
  badge: '/sloot_logo.png',
  vibrate: [200, 100, 200],
  data: {
    url: window.location.origin
  }
};
